import {Route, Switch, Redirect} from 'react-router';
import * as React from 'react';
import SignUpPage from './project/pages/SignUpPage';
import SignInPage from './project/pages/SignInPage';
import ResetPasswordPage from './project/pages/ResetPasswordPage';
import LessonPage from './project/pages/LessonPage';
import ExercisesPage from './project/pages/ExercisesPage';
import EditLessonPage from './project/pages/EditLessonPage';
import HomePageOld from './project/pages/HomePageOld';
import EditExercisePage from './project/pages/EditExercisePage';
import ChangePasswordPage from './project/pages/ChangePasswordPage';
import WebGLPage from './project/pages/WebGLPage';
import LinearPage from './project/pages/LinearPage';
import CoursePage from './project/pages/CoursePage';
import EditCoursePage from './project/pages/EditCoursePage';
import PreferencesPage from './project/pages/PreferencesPage';
import EditStoryPage from './project/pages/EditStoryPage';
import HomePage from './project/pages/HomePage';
import BusinessSignUpPage from './project/pages/BusinessSignUpPage';
import DashboardPage from './project/pages/DashboardPage';
import MissionPage from './project/pages/MissionPage';
import ContactPage from './project/pages/ContactPage';
import ExercisePage from './project/pages/ExercisePage';

interface IReactGA {
	pageview (path: string): void;
}

interface Props {
	reactGA: IReactGA;
}

export default class RouterBody extends React.Component<Props, {}> {

	render () {
		this.props.reactGA.pageview(window.location.pathname);

		return (
			<Switch>
				<Route exact path='/' component={HomePage}/>
				<Route exact path='/mission' component={MissionPage}/>
				<Route exact path='/contact' component={ContactPage}/>
				<Route exact path='/my-courses' component={HomePage}/>
				<Route exact path='/businesses' component={HomePage}/>
				<Route exact path='/schools' component={HomePage}/>
				<Route exact path='/exercises/review' component={ExercisesPage}/>
				<Route exact path='/exercises/review/:courseId' component={ExercisesPage}/>
				<Route exact path='/course/new/public' component={EditCoursePage}/>
				<Route exact path='/course/new/organization' component={EditCoursePage}/>
				<Route exact path='/course/new' component={EditCoursePage}/>
				<Route exact path='/course/:id/*/edit' component={EditCoursePage}/>
				<Route exact path='/course/:id/*' component={CoursePage}/>
				<Route exact path='/lesson/new/:courseId' component={EditLessonPage}/>
				<Route exact path='/lesson/new' component={EditLessonPage}/>
				<Route exact path='/lesson/:lessonId/*/exercise/new/:templateId' component={EditExercisePage}/>
				<Route exact path='/lesson/:lessonId/*/exercise/new' component={EditExercisePage}/>
				<Route exact path='/lesson/:lessonId/*/exercise/:id/edit' component={EditExercisePage}/>
				<Route exact path='/lesson/:lessonId/*/exercise/:id/*' component={ExercisePage}/>
				<Route exact path='/lesson/:id/*/edit-story' component={EditStoryPage}/>
				<Route exact path='/lesson/:id/*/edit' component={EditLessonPage}/>
				<Route exact path='/lesson/:id/exercises' component={ExercisesPage}/>
				<Route exact path='/lesson/:id/*/:activeTab' component={LessonPage}/>
				<Route exact path='/lesson/:id/*' component={LessonPage}/>
				<Route exact path='/preferences' component={PreferencesPage}/>
				<Route exact path='/sign-in' component={SignInPage}/>
				<Route exact path='/sign-up' component={SignUpPage}/>
				<Route exact path='/businesses/sign-up' component={BusinessSignUpPage}/>
				<Route exact path='/reset-password' component={ResetPasswordPage}/>
				<Route exact path='/change-password' component={ChangePasswordPage}/>

				<Route exact path='/webgl' component={WebGLPage}/>

				<Route exact path='/dashboard' component={DashboardPage}/>
				<Route exact path='/dashboard/my-courses' component={DashboardPage}/>
				<Route exact path='/web' component={HomePageOld}/>
				<Route exact path='/linear' component={LinearPage}/>

				<Redirect to='/'/>
			</Switch>
		);
	}
}


// WEBPACK FOOTER //
// ./code/RouterBody.tsx